import axios from "axios";
import Component from "vue-class-component";
import { Vue, Inject } from "vue-property-decorator";
import AccountService from "@/core/account.service";
import GlobalMixin from "@/shared/mixins/global-mixin";
@Component({
  watch: {
    $route() {
      this.$root.$emit("bv::hide::modal", "login-page");
    },
  },
})
export default class LoginForm extends GlobalMixin {
  @Inject("accountService")
  private accountService: () => AccountService;
  public authenticationError = null;
  public login = null;
  public password = null;
  public rememberMe: boolean = null;

  public doLogin(): void {
    const data = { username: this.login, password: this.password, rememberMe: this.rememberMe };
    axios
      .post("api/authenticate", data)
      .then((result) => {
        const bearerToken = result.headers.authorization;
        if (bearerToken && bearerToken.slice(0, 7) === "Bearer ") {
          const jwt = bearerToken.slice(7, bearerToken.length);
          if (this.rememberMe) {
            localStorage.setItem("jhi-authenticationToken", jwt);
          } else {
            sessionStorage.setItem("jhi-authenticationToken", jwt);
          }
        }
        this.authenticationError = false;
        this.$root.$emit("bv::hide::modal", "login-page");
        this.accountService().retrieveAccount();
        this.redirect();
      })
      .catch(() => {
        this.authenticationError = true;
      });
  }
}
